export function add_attribute_value(form, new_attribute_value, type) {
    if (!type?.name) return;

    const key = type.name.toLowerCase().trim();

    const value = Reflect.get(new_attribute_value, key);
    if (!value) return;

    if (!Reflect.has(form, "attributes") || typeof form.attributes !== "object") {
        form.attributes = {};
    }

    if (!Reflect.has(form.attributes, key)) {
        Reflect.set(form.attributes, key, []);
    }

    const arr = Reflect.get(form.attributes, key);

    String(value)
        .split(",")
        .map((item) => item.toLowerCase().trim())
        .filter(Boolean)
        .forEach((clean_value) => {
            if (!arr.includes(clean_value)) {
                arr.push(clean_value);
            }
        });

    Reflect.set(new_attribute_value, key, "");
}


export function group_attributes(attributes = []) {
    const grouped = {};
    const order = [];

    (attributes || []).forEach(attr => {
        if (!attr) return;

        const raw = attr.attribute_type || '';
        const key = raw.toLowerCase().trim();

        if (!Reflect.has(grouped, key)) {
            Reflect.set(grouped, key, {
                key,
                label: raw,
                values: []
            });

            order.push(key);
        }

        Reflect.get(grouped, key).values.push(attr);
    });

    return order.map(key => Reflect.get(grouped, key));
}


export function remove_attribute(form, type_name, index) {
    const key = type_name.toLowerCase().trim();

    const values = Reflect.get(form?.attributes || {}, key);

    if (!Array.isArray(values)) return;

    values.splice(index, 1);

    if (values.length === 0) {
        Reflect.deleteProperty(form.attributes, key);
    }
}
